import { ParameterData } from '@/core/types'

import { getCodeSigns } from './variableCode/codeSigns'
import { formatParameterLiteral } from './variableCode/formatParameterLiteral'

export function buildVariableCode(
  parameters: ParameterData[],
  variableCode: string,
  valueMap: Record<string, string | number>,
  technology = ''
): string {
  const signs = getCodeSigns(technology)

  return parameters
    .map((param) => {
      const declaration = variableCode.replaceAll('{name}', param.name).replaceAll('{class}', param.type)
      const rawValue = valueMap[param.name] ?? ''
      const formatted = formatParameterLiteral(rawValue, param, technology, signs)
      return `${declaration}${formatted}${signs.endOfInstruction}`
    })
    .join('\n')
}
